import React from "react";
import { BlendIcon, SettingsIcon, UsersRoundIcon } from "../Icons";
import { SERVICE_TIERS } from "../content";

const TIER_ICONS = [SettingsIcon, BlendIcon, UsersRoundIcon] as const;

// The three levels of support, shared by the programme catalogue and each programme page. The
// heading level follows the section it sits in, so the page outline doesn't skip a level.
export default function SupportTierCards({ heading: Heading = "h3" }: { heading?: "h3" | "h4" }) {
  return (
    <div className="tw-grid tw-grid-cols-3 tw-gap-5 sm:tw-grid-cols-1">
      {SERVICE_TIERS.map((tier, index) => {
        const Icon = TIER_ICONS[index];

        return (
          <article
            key={tier.shortName}
            className="tw-rounded-[24px] tw-border tw-border-[#c8deec] tw-bg-white tw-p-7 tw-shadow-[0_14px_40px_rgba(32,75,110,.06)] xs:tw-rounded-[22px] xs:tw-p-5"
          >
            <Icon aria-hidden className="tw-h-7 tw-w-7 tw-text-[#087bd3]" />
            <Heading className="tw-mt-5 tw-mb-0 tw-text-2xl tw-font-black tw-tracking-[-.03em] tw-text-[#173754]">
              {tier.shortName}
            </Heading>
            <p className="tw-mt-3 tw-mb-0 tw-leading-7 tw-text-[#60768c]">
              {tier.summary} {tier.body}
            </p>
          </article>
        );
      })}
    </div>
  );
}
